import { PaginatedTable } from "components/Table/Table";
import { THRESHOLD_TABLE_COLUMNS } from "./ThresholdTableColumns";

import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { RuleLevel } from "interfaces/rule";
import { ChangeEvent, useState, SetStateAction } from "react";
import { EditRuleLevelDialog } from "./RuleLevelDialog/EditRuleLevelDialog";

export interface RuleTableProps {
  loading: boolean;
  ruleLevelData: RuleLevel[];
  ruleId: number;
  onEditRuleLevel: () => void;
}

export const NewThresholdTable = ({
  loading,
  ruleLevelData,
  ruleId,
  onEditRuleLevel
}: RuleTableProps): JSX.Element => {
  const [pageSize, setPageSize] = useState(50);
  const [pageIndex, setPageIndex] = useState(0);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [ruleLevelToEdit, setRuleLevelToEdit] = useState<RuleLevel>();

  const handleUpdatePageSize = (size: number): void => {
    setPageSize(size);
    setPageIndex(0);
  };

  const handleCloseEditDialog = (): void => {
    setEditDialogOpen(false);
    setRuleLevelToEdit(undefined);
  };

  const handleEditDialog = (
    ruleLevel: SetStateAction<RuleLevel | undefined>
  ): void => {
    setEditDialogOpen(true);
    setRuleLevelToEdit(ruleLevel);
  };

  const columns = THRESHOLD_TABLE_COLUMNS({ handleEditDialog });

  return (
    <>
      <ThresholdTableScroll elevation={0}>
        <PaginatedTable
          data={ruleLevelData ?? []}
          columns={columns}
          loading={loading}
          dataQa="threshold-table"
          page={pageIndex}
          count={ruleLevelData.length}
          pageSize={pageSize}
          onPageChange={(event, page) => setPageIndex(page)}
          onSortingChange={() => {}}
          onPageSizeChange={(
            event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
          ) => handleUpdatePageSize(Number(event.target.value))}
        />
      </ThresholdTableScroll>
      <EditRuleLevelDialog
        ruleId={ruleId}
        ruleLevel={ruleLevelToEdit}
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        onSuccess={() => {
          onEditRuleLevel();
          handleCloseEditDialog();
        }}
      />
    </>
  );
};

const ThresholdTableScroll = styled(Paper)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  border: 1px solid rgba(224, 224, 224, 1);
  border-radius: 4px;
`;
